import { createContext } from "react";

type ModalContextState = {
  onClose?: () => void;
  disableModalExit?: boolean;
};

export const ModalContext = createContext<ModalContextState>({});
